"use client";

import { useTranslation } from "react-i18next";

import type { ShelfLifeStatus } from "@/shared/lib/expiry-status";
import { cn } from "@/shared/lib/utils";

const SHELF_LIFE_STATUS_DOT: Record<ShelfLifeStatus, string> = {
  active: "bg-emerald-500",
  expiringSoon: "bg-amber-500",
  expired: "bg-red-500",
  unknown: "bg-muted-foreground/30",
};

export function ShelfLifeCell({
  text,
  status,
  className,
}: {
  text: string;
  status: ShelfLifeStatus;
  className?: string;
}) {
  const { t } = useTranslation();
  const label = status === "unknown" ? undefined : t(`expiryStatus.${status}` as const);
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <span
        aria-label={label}
        title={label}
        className={cn("inline-block size-2 shrink-0 rounded-full", SHELF_LIFE_STATUS_DOT[status])}
      />
      <span>{text || "—"}</span>
    </span>
  );
}
